<template>
  <div class="flex justify-center px-2 py-3">
    <div class="text-c-3 p-2 text-sm"><slot /></div>
  </div>
</template>
